import React from 'react';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import ForgotPasswordPanel from '../../components/ForgotPasswordPanel';

import { Section, Wrapper, Content, Footer } from './ForgotPasswordPage.style';

const ForgotPasswordPage = () => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <>
      <Helmet
        title={intl.formatMessage({ id: 'PAGE_TITLE.FORGOT_PASSWORD' })}
      />

      <Section>
        <Wrapper theme={theme.sign.wrapper.default}>
          <Content>
            <ForgotPasswordPanel />
          </Content>
          <Footer theme={theme.sign.footer.default}>
            By signing in, you accept{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy policy
            </a>{' '}
            <br />
            (including Use of Cookies and Other
            <br /> Technologies) and{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Terms of use
            </a>
          </Footer>
        </Wrapper>
      </Section>
    </>
  );
};

export default ForgotPasswordPage;
